export const leadFinishConstants = {
  MAIL_SUCCESS: 'MAIL_SUCCESS',
  MAIL_FAIL: 'MAIL_FAIL',
};
